'use strict';

angular.module('mobile-apps').factory('AppBackups', [
    '$resource',
    function ($resource) {
		return $resource(
			'v1/projects/:mobileAppId/backups',
			{
				mobileAppId: '@mobileAppId'
			},
			{
				get: {
					method:'GET',
					isArray: true,
					cache : false
				},
				create: {
					method:'POST',
					cache: false
				},
				import: {
					url: 'v1/projects/:mobileAppId/backups/:backupDate/:backupType',
					method: 'GET',
					cache: false
				},
				delete: {
					url: 'v1/projects/:mobileAppId/backups/:backupDate',
					method: 'DELETE',
					cache: false
				}

			}
		);
    }
]);
